import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../Global/LayoutTable'
import { GET_ALL_WATER_TRUCKS } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import {
  arrayStatus,
  fnStatusArrayCanSeeNewRequest,
} from '../../../../const/constStatuses_waterTruckRequest'
import {
  CREATE_ROUTE_POINT,
  GET_ROUTE_POINT_BY_ID,
  UPDATE_ROUTE_POINT,
} from '../../../../graphql/Catalog/Trucks/Routes/routesPoints'
import * as yup from 'yup'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import InputController from '../../../Global/InputController'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import Box from '../../../Global/Box'
import { GET_ALL_WATER_STATIONS } from '../../../../graphql/Catalog/WaterStations/waterstations'
import { GET_ALL_ROUTES } from '../../../../graphql/Catalog/Trucks/Routes/routesTrucks'
import { currencyFormatToAny } from '../../../Helpers/FormatNumber'
import { GET_CAPACITY_TRUCKS } from '../../../../graphql/Catalog/Trucks/trucks'
import moment from 'moment'
import {
  priorityOptions,
  typeDeliveryOptions,
} from '../WaterTruckRequest/WaterTruckRequestNewAndEdit'
import Swal from 'sweetalert2'
import ProgressBarStatus from '../../../Global/ProgressBarStatus'
import PriorityBox from '../WaterTruckRequest/components/PriorityBox'
import { get } from 'lodash'
import { GET_ALL_COLONIES } from '../../../../graphql/Global/sepomex'

const RoutesTrucksNew = ({
  //ADD ROUTES POINTS TO ROUTE AND EDIT ROUTE POINT
  routeId,
  waterRequestId,
  setCloseModalAux,
  refModalAux,
  fetchsData,
  routeIsOnRoute,
  routeComplete,
  disabledFieldsRoutePoint,
  //WIZARD
  refWizard,
  dataWizard,
  setDataWizard,
  setIsValidSteps,
  isLastPoint,
}) => {
  const methodStatusOptions = fnStatusArrayCanSeeNewRequest()

  const nameColumnDateType = [
    // {
    //   value: 'planning_date',
    //   label: 'Fecha de planificación',
    // },
    // {
    //   value: 'completed_at',
    //   label: 'Fecha de completado',
    // },
    {
      value: 'createdAt',
      label: 'Fecha de creación',
    },
  ]

  // const getStatusId = arrayStatus.find((status) => status.name === 'nuevo')

  const { hideLoading, showLoading } = useLoading()

  const [options, setOptions] = useState({
    water_station_id: [],
    route_id: [],
    capacity: [],
    priority: [],
    status_id: [],
  })

  const validationSchema = waterRequestId
    ? yup.object().shape({
        route_id: !routeIsOnRoute
          ? yup.string()
          : yup.string().required('Este campo es requerido'),
        water_station_id: yup.string().required('Este campo es requerido'),
      })
    : yup.object().shape({})

  const {
    methods,
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const [dataTable, setDataTable] = useState([])
  const [idsRoutes, setIdsRoutes] = useState([])
  const [capacity, setCapacity] = useState(null)
  const [limitCapacity, setLimitCapacity] = useState(null)
  const [count, setCount] = useState(0)
  const [clearSelect, setClearSelect] = useState(false)
  const [statusSelected, setStatusSelected] = useState(null)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      status_id: null,
      priority: null,
      order: [{ column: 'priority', type: 'DESC' }],
      nameColumnDateType: 'createdAt',
      dateFrom: null,
      dateTo: null,
      type_delivery: null,
      colony_id: null,
    },
  })

  const [filterChoosen, setFilterChoosen] = useState([
    // {
    //   id: 'volume',
    //   name: 'Volumen',
    //   placeholder: 'Volumen',
    //   options: options.capacity,
    //   onChange: (e) => handleFilterChange(e, 'volume'),
    //   value: capacity,
    //   menuPosition: 'fixed',
    // },
    {
      id: 'status',
      name: 'Estatus',
      placeholder: 'Estatus',
      options: methodStatusOptions,
      isClearable: true,
      isSearchable: true,
      onChange: (e) => handleFilterChange(e, 'status_id'),
    },
    {
      id: 'priority',
      name: 'Prioridad',
      placeholder: 'Prioridad',
      options: priorityOptions,
      isClearable: true,
      isSearchable: true,
      onChange: (e) => handleFilterChange(e, 'priority'),
    },
    {
      id: 'type_delivery',
      name: 'Tipo de entrega',
      placeholder: 'Tipo de entrega',
      options: typeDeliveryOptions,
      isClearable: true,
      isSearchable: true,
      onChange: (e) => handleFilterChange(e, 'type_delivery'),
    },
    {
      id: 'colonia',
      name: 'colony_id',
      placeholder: 'Colonia',
      options: [],
      isClearable: true,
      isSearchable: true,
      onChange: (e) => handleFilterChange(e, 'colony_id'),
      value: null,
    },
  ])

  const { loading, error, data, refetch } = useQuery(GET_ALL_WATER_TRUCKS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      filters: {
        status_id: pagePagination.filters.status_id,
        order: pagePagination.filters.order,
        routesWithoutAssigned: true,
        // volumeLte: capacity,
        volume: capacity,
        priority: pagePagination.filters.priority,
        nameColumnDateType: pagePagination.filters.nameColumnDateType,
        dateFrom: pagePagination.filters.dateFrom,
        dateTo: pagePagination.filters.dateTo,
        type_delivery: pagePagination.filters.type_delivery,
        colony_id: pagePagination.filters.colony_id,
      },
    },
    fetchPolicy: 'no-cache',
    skip: waterRequestId,
  })

  const {
    loading: loadingRoutePoint,
    error: errorRoutePoint,
    data: dataRoutePoint,
    refetch: refetchRoutePoint,
  } = useQuery(GET_ROUTE_POINT_BY_ID, {
    variables: {
      id: waterRequestId ? +waterRequestId.id : 0,
    },
    fetchPolicy: 'no-cache',
    skip: !waterRequestId,
  })

  const {
    loading: loadingWaterStations,
    error: errorWaterStations,
    data: dataWaterStations,
  } = useQuery(GET_ALL_WATER_STATIONS, {
    variables: {},
    fetchPolicy: 'cache-and-network',
    skip: !waterRequestId,
  })

  const {
    loading: loadingColonies,
    error: errorColonies,
    data: dataColonies,
  } = useQuery(GET_ALL_COLONIES, {
    fetchPolicy: 'no-cache', //always!
  })

  const {
    loading: loadingRoutes,
    error: errorRoutes,
    data: dataRoutes,
  } = useQuery(GET_ALL_ROUTES, {
    variables: {
      filters: {
        // dateGte: true,
        volume: waterRequestId ? +waterRequestId.volumen : null,
        filterOnlyNotAssigned: true,
      },
    },
    fetchPolicy: 'cache-and-network',
    skip: !waterRequestId,
  })

  // const {
  //   loading: loadingCapacity,
  //   error: errorCapacity,
  //   data: dataCapacity,
  // } = useQuery(GET_CAPACITY_TRUCKS, {
  //   variables: {},
  //   fetchPolicy: 'cache-and-network',
  // })

  const [createRoutePoint] = useMutation(CREATE_ROUTE_POINT)
  const [updateRoutePoint] = useMutation(UPDATE_ROUTE_POINT)

  useEffect(() => {
    if (fnStatusArrayCanSeeNewRequest) {
      const optionsStatus = methodStatusOptions.map((status) => {
        return {
          value: status.id,
          label: status.lablMain,
        }
      })

      setOptions((prev) => ({
        ...prev,
        status_id: optionsStatus,
      }))
    }
  }, [fnStatusArrayCanSeeNewRequest])

  useEffect(() => {
    try {
      if (!waterRequestId) return
      if (loadingRoutePoint) return
      if (errorRoutePoint) throw errorRoutePoint
      if (!dataRoutePoint) throw new Error('No se encontraron datos')

      const { getRoutePointById } = dataRoutePoint

      reset({
        route_id: getRoutePointById.route_id,
        water_station_id: getRoutePointById.water_station_id,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingRoutePoint, errorRoutePoint, dataRoutePoint])

  useEffect(() => {
    try {
      if (waterRequestId) return
      if (loading) return
      if (error) throw error

      if (!data) throw new Error('No se encontraron datos')

      const { getAllWaterTruckRequests } = data

      const infoRequest = getAllWaterTruckRequests.rows.map((request) => {
        console.log({
          request,
        })

        return {
          id: request.id,
          folio: request.folio,
          extemporaneo: request.is_extemporaneous ? 'Si' : 'No',
          fecha: moment(request.createdAt).format('DD/MM/YYYY'),
          tipo: request.type_delivery,
          prioridad: (
            <PriorityBox
              priority={request.priority}
              normalStyle={{
                backgroundColor: '#DBE6FF',
                color: '#374151',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              urgentStyle={{
                backgroundColor: '#DA1E28',
                color: '#FFFFFF',
                border: '0px',
                padding: '8px 2px',
                borderRadius: '4px',
                width: '100%',
                marginRight: '100px',
              }}
              showImage={false}
            />
          ),
          requerido: request.volume + 'm³',
          estatus: (
            <ProgressBarStatus
              // category={categorModule}
              status={request.StatusOfWaterTruckRequest}
            />
          ),
          colonia: request?.ColonyOfWaterTruckRequest?.name ?? 'Sin Colonia',
          dirección: request?.AddressOfWaterTruckRequest?.address_full,
          request__omit: request,
        }
      })

      setDataTable(infoRequest)
      setCount(getAllWaterTruckRequests.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    try {
      if (loadingWaterStations) return
      if (errorWaterStations) throw errorWaterStations
      if (!dataWaterStations) return

      const { getAllWaterStations } = dataWaterStations

      const optionsWaterStations = getAllWaterStations.rows.map(
        (waterStation) => {
          return {
            value: waterStation.id,
            label: waterStation.name,
          }
        }
      )

      setOptions((prev) => ({
        ...prev,
        water_station_id: optionsWaterStations,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataWaterStations, errorWaterStations, loadingWaterStations])

  useEffect(() => {
    try {
      if (!waterRequestId) return
      if (loadingRoutes) return
      if (errorRoutes) throw errorRoutes
      if (!dataRoutes) throw new Error('No se encontraron datos')

      const { getAllRoutes } = dataRoutes

      const optionsRoutes = getAllRoutes.rows.map((route) => {
        return {
          value: route.id,
          label: `${route.invoice} - ${route.RouteToUser.name} ${route.RouteToUser.first_name} - ${route.RouteToTrucks.plate_number}`,
        }
      })

      setOptions((prev) => ({
        ...prev,
        route_id: optionsRoutes,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataRoutes, errorRoutes, loadingRoutes])

  useEffect(() => {
    if (waterRequestId) return

    if (dataWizard && dataWizard.dataStepRoute) {
      setCapacity(+dataWizard.dataStepRoute.volume)
      setLimitCapacity(+dataWizard.dataStepRoute.volume)
    }
  }, [dataWizard])

  useEffect(() => {
    if (routeId && routeComplete) {
      setCapacity(+routeComplete.volume)
      setLimitCapacity(+routeComplete.volume)
      if (routeComplete.RouteToRoutePoints.length > 0) {
        setStatusSelected(
          routeComplete.RouteToRoutePoints[0].RoutePointsToWaterTruckRequest
            .status_id
        )
      }
    }
  }, [routeId])

  useEffect(() => {
    if (!capacity) return
    if (+limitCapacity < +capacity) {
      return toastSweetAlert(
        {
          mode: 'error',
          message: `La capacidad de la ruta es de ${limitCapacity}m³. No puedes asignar peticiones de mayor volumen`,
        },
        setCapacity(limitCapacity)
      )
    }

    setFilterChoosen((prev) =>
      prev.map((filter) => ({
        ...filter,
        value: capacity,
      }))
    )
  }, [capacity])

  useEffect(() => {
    if (idsRoutes.length === 1 && routeComplete) {
      if (routeComplete.RouteToRoutePoints.length === 0) {
        setStatusSelected(idsRoutes[0].status_id)
      }
    }
    if (idsRoutes.length === 0 && routeComplete) {
      if (routeComplete.RouteToRoutePoints.length === 0) {
        setStatusSelected(null)
      }
    }

    if (idsRoutes.length === 1 && !routeComplete) {
      setStatusSelected(idsRoutes[0].status_id)
    }

    if (idsRoutes.length === 0 && !routeComplete) {
      setStatusSelected(null)
    }
  }, [idsRoutes])

  //Select Colonies
  useEffect(() => {
    if (!loadingColonies && !errorColonies) {
      if (dataColonies) {
        const colonies = dataColonies.getAllColonies.map((item) => ({
          value: item.id,
          label: item.name,
          nocolonia: item.nocolonia,
        }))

        setFilterChoosen((prev) =>
          prev.map((filter) => {
            if (filter.id === 'colonia') {
              return {
                ...filter,
                options: colonies,
                value: null,
              }
            }
            return filter
          })
        )
      }
    }
  }, [dataColonies, loadingColonies, errorColonies])

  const handleFilterChange = (e, type) => {
    // if (!e) return
    if (type === 'volume') {
      return setCapacity(e ? e.value : null)
    }

    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [type]: e ? e.value : null,
      },
    }))
  }

  const handleSelectedRows = (rows) => {
    try {
      let newIds = []
      if (rows.selectedCount === 0) return setIdsRoutes([])

      rows.selectedRows.forEach((row) => {
        newIds.push({
          id: row.id,
          status_id: row.request__omit.status_id,
        })
      })
      setIdsRoutes(newIds)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleAddNewButton = async (e) => {
    if (idsRoutes.length === 0)
      return toastSweetAlert({
        mode: 'error',
        message: 'Debes seleccionar al menos una petición',
      })

    const response = await toastSweetAlert({
      mode: 'modalConfirmCancel',
      icon: 'info',
      message: '¿Estás seguro de asignar las peticiones a la ruta?',
      confirmButtonText: 'Sí, asignar',
      denyButtonText: 'No',
    })

    if (!response.isConfirmed) return

    setDataWizard((prev) => ({
      ...prev,
      dataStepRequest: idsRoutes,
    }))

    setIsValidSteps((prev) => ({
      ...prev,
      stepRequest: true,
    }))
  }

  const onSubmit = async (data) => {
    try {
      const originalRoute = parseInt(
        dataRoutePoint?.getRoutePointById?.route_id
      )
      const currentRouteForm = parseInt(data.route_id)
      const isSameRoute = originalRoute === currentRouteForm

      if (isLastPoint && !isSameRoute) {
        const response = await toastSweetAlert({
          mode: 'modalConfirmCancel',
          icon: 'info',
          message:
            'Al hacer esta acción, la ruta quedara sin solicitudes de entrega, ¿Estas seguro de hacer esto?',
        })
        if (!response.isConfirmed) return
      }
      showLoading()

      if (waterRequestId) {
        const { data: dataUpdate } = await updateRoutePoint({
          variables: {
            updateRoutePointId: +waterRequestId.id,
            routePointInput: {
              route_id: +data.route_id,
              water_station_id: +data.water_station_id,
            },
          },
        })
        if (dataUpdate.updateRoutePoint) {
          await fetchsData.refetchRoutesPoints()
          await fetchsData.refetchMain()
          return toastSweetAlert({
            mode: 'ok',
            message: 'Se actualizó correctamente el punto de ruta',
          })
        }
      }

      // const requestId = idsRoutes.map((item) => item.id)

      const { data: dataCreate } = await createRoutePoint({
        variables: {
          waterTruckRequest: idsRoutes.map((item) => item.id),
          routeId: +routeId,
        },
      })

      if (dataCreate.createRoutePoint) {
        await fetchsData.refetchRoutesPoints()
        await fetchsData.refetchMain()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Se asignaron correctamente las peticiones a la ruta',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      setCloseModalAux(true)
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={
            refWizard
              ? handleSubmit(handleAddNewButton)
              : handleSubmit(onSubmit)
          }
        >
          <Box
            withCard={false}
            btnSubmit
            btnSubmitText={waterRequestId ? 'Actualizar' : 'Agregar servicios'}
            content={
              <>
                {waterRequestId ? (
                  <div className="row p-3">
                    {!routeIsOnRoute && (
                      <div className="col-lg-6">
                        <InputController
                          control={control}
                          name="route_id"
                          label="Ruta"
                          inputType="choosen"
                          options={options.route_id}
                          menuPosition="fixed"
                        />
                      </div>
                    )}
                    <div className="col-lg-6">
                      <InputController
                        control={control}
                        name="water_station_id"
                        label="Estación de agua"
                        inputType="choosen"
                        options={options.water_station_id}
                        menuPosition="fixed"
                        disabled={disabledFieldsRoutePoint}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                    <LayoutTable
                      hideId
                      customHeaderComponent={
                        <>
                          <label htmlFor="">
                            Seleccionados: {idsRoutes.length}
                          </label>
                        </>
                      }
                      // headerComponents={
                      //   <>
                      //     <label htmlFor="">Seleccionados: {idsRoutes.length}</label>
                      //   </>
                      // }
                      data={dataTable}
                      loadingData={loading}
                      totalCount={count}
                      pagePagination={pagePagination}
                      setPagePagination={setPagePagination}
                      hideActions
                      // clearSelectedRows={clearSelect}
                      selectableRows
                      onSelectedRowsChange={(rows) => handleSelectedRows(rows)}
                      // selectableRowsNoSelectAll={true}
                      // selectableRowSelected={(row) => {
                      //   return idsRoutes.includes(row.id)
                      // }}
                      exportImportButton={false}
                      withCard={false}
                      hideAddNew
                      filterChoosen={filterChoosen}
                      cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
                      cols_search_div="col-12"
                      cols_filters="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3"
                      cols_filters_div="col-12"
                      isFilterRangeShow
                      filterRangeProps={{
                        from: {
                          // value: pagePagination.filters.dateFrom,
                          // label: 'Fecha inicio',
                        },
                        to: {
                          // value: pagePagination.filters.dateTo,
                          // label: 'Fecha fin',
                        },
                        changeFilterDateRange: (e, label) => {
                          if (label === 'from')
                            return handleFilterChange(
                              { value: e.target.value },
                              'dateFrom'
                            )
                          if (label === 'to')
                            return handleFilterChange(
                              { value: e.target.value },
                              'dateTo'
                            )
                        },
                      }}
                      filterThird
                      filterOnChangeThird={(e) => {
                        handleFilterChange(
                          { value: e.target.value },
                          'nameColumnDateType'
                        )
                      }}
                      filterOptionsThird={nameColumnDateType.map((item) => (
                        <option value={item.value} key={item.value}>
                          {item.label}
                        </option>
                      ))}
                      defaultValueSelectThird={'createdAt'}
                    />
                  </>
                )}
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default RoutesTrucksNew
